import Cookies from 'js-cookie';

// Cookie expiration - 30 days by default
const COOKIE_EXPIRATION = 30;

// Set secure and SameSite attributes based on environment
const getCookieOptions = () => {
  return {
    expires: COOKIE_EXPIRATION,
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'strict'
  };
};

export const setAuthCookies = (userData) => {
  const { _id, email, type, username, first_login, token } = userData;
  const cookieOptions = getCookieOptions();
  
  // Set individual cookies for auth data
  Cookies.set('auth_token', token, cookieOptions);
  Cookies.set('auth_user_id', _id, cookieOptions);
  Cookies.set('auth_email', email, cookieOptions);
  Cookies.set('auth_type', type || 'Free', cookieOptions);
  Cookies.set('auth_username', username, cookieOptions);
  Cookies.set('auth_first_login', first_login.toString(), cookieOptions);
  
  // Also set localStorage for compatibility with existing code
  localStorage.setItem('token', token);
  localStorage.setItem('_id', _id);
  localStorage.setItem('email', email);
  localStorage.setItem('type', type || 'Free');
  localStorage.setItem('username', username);
  localStorage.setItem('first_login', first_login.toString());
};

export const getAuthCookies = () => {
  return {
    token: Cookies.get('auth_token'),
    _id: Cookies.get('auth_user_id'),
    email: Cookies.get('auth_email'),
    type: Cookies.get('auth_type'),
    username: Cookies.get('auth_username'),
    first_login: Cookies.get('auth_first_login')
  };
};

export const clearAuthCookies = () => {
  // Clear all auth cookies
  Cookies.remove('auth_token');
  Cookies.remove('auth_user_id');
  Cookies.remove('auth_email');
  Cookies.remove('auth_type');
  Cookies.remove('auth_username');
  Cookies.remove('auth_first_login');
  
  // Also clear localStorage
  localStorage.removeItem('token');
  localStorage.removeItem('_id');
  localStorage.removeItem('email');
  localStorage.removeItem('type');
  localStorage.removeItem('username');
  localStorage.removeItem('first_login');
};

export const isAuthenticated = () => {
  // Check both cookies and localStorage
  const cookieToken = Cookies.get('auth_token');
  const localToken = localStorage.getItem('token');
  
  // If token exists in either cookies or localStorage, consider user authenticated
  return !!cookieToken || !!localToken;
};

// Function to synchronize data between cookies and localStorage
export const syncAuthData = () => {
  const cookieData = getAuthCookies();
  const localData = {
    token: localStorage.getItem('token'),
    _id: localStorage.getItem('_id'),
    email: localStorage.getItem('email'),
    type: localStorage.getItem('type'),
    username: localStorage.getItem('username'),
    first_login: localStorage.getItem('first_login')
  };
  
  // If cookies exist but localStorage doesn't, restore from cookies
  if (cookieData.token && !localData.token) {
    localStorage.setItem('token', cookieData.token);
    localStorage.setItem('_id', cookieData._id);
    localStorage.setItem('email', cookieData.email);
    localStorage.setItem('type', cookieData.type || 'Free');
    localStorage.setItem('username', cookieData.username);
    localStorage.setItem('first_login', cookieData.first_login);
    return true;
  }
  
  // If localStorage exists but cookies don't, restore from localStorage
  if (localData.token && !cookieData.token) {
    setAuthCookies(localData);
    return true;
  }
  
  return false;
};